import CopySelect from '../generic/CopySelect';
import { copyCountrySplit } from './actions';
import { connectEditor } from './connect-editor';

export default connectEditor(
  ({ quote, quoteLinesById, productsById }, { id }) => {
    return {
      id: `quoteLines-${id}-copySelect`,
      title: 'Country Split',
      value: quoteLinesById[id].countrySplit,
      options: quote.quoteLines
        .map(quoteLineId => quoteLinesById[quoteLineId])
        .map(quoteLine => {
          const product = productsById[quoteLine.productId];
          return {
            target: quoteLine.id,
            label: `${product.business}, ${product.productGroup}: ${product.name}`,
          };
        })
        .filter(option => option && option.target !== id), // drop null options and the source line itself
    };
  },
  {
    onClick: (countrySplit, targetIds) => {
      return copyCountrySplit(countrySplit, targetIds);
    },
  },
)(CopySelect);
